import { render, staticRenderFns } from "./ActiveChat.vue?vue&type=template&id=1f8ba60c&scoped=true&"
import script from "./ActiveChat.vue?vue&type=script&lang=js&"
export * from "./ActiveChat.vue?vue&type=script&lang=js&"
import style0 from "./ActiveChat.vue?vue&type=style&index=0&id=1f8ba60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ba60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
